<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-main">Terms of Service for TopEdu App</h3></div>
    </div>
    <!-- End Bread crumb -->
    <!-- Container fluid  -->
    <div class="container-fluid">
      <!-- Start Page Content -->
      <div class="row">
        <div class="col-lg-8 col-md-10 col-sm-12">
          <div class="card">
            <div class="card-body">
              <h3>General</h3>
              <div>
                <div class="flex-column">
                  <div class="flex-column f-20 padding-15 margin-start-60">
                    <div>
                      <div class="f-18 text-align-start margin-bottom-4">
                        <div class="flex-row responsive">
                          <div class="flex-7">
                                            <span>
                                                1.
                                            </span>
                          </div>
                          <div class="flex-100">
                            <div class="flex-column">
                              <div class="flex-column">
                                <div>
                                  <span class="f-18 text-align-start margin-bottom-4">אתר האינטרנט www.SmartFleet.co.il (להלן: "האתר") הינו אתר ברשת האינטרנט, המספק שרות של תוכנה לניהול ציי רכב ונהגים (להלן: "השירות" או "השירותים"). בעלת האתר ומפעילתו הינה חברת בקצועיות בתעבורה בע"מ ח.פ. 5 שמשרדה רשום ברח' העצמאות 40, באר שבע (להלן: "החברה").</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="flex-row responsive">
                          <div class="flex-7">
                                            <span>
                                                2.
                                            </span>
                          </div>
                          <div class="flex-100">
                            <div class="flex-column">
                              <div class="flex-column">
                                <div>
                                                        <span class="f-18 text-align-start margin-bottom-4">
                                                            הוראות מסמך תנאי שימוש זה יחולו על כל פעולה שתבוצע על ידי המשתמש באתר. מסמך תנאי שימוש זה מהווה חוזה התקשרות מחייב בין המשתמש ובין פאוורלינק, לכל דבר ועניין. מובהר כי גלישה באתר ו/או ביצוע פעולות באתר, מהוות הסכמת המשתמש לקבל ולנהוג על פי הוראות תנאי השימוש. אם אינך מסכימ/ה לתנאי השימוש, הנך מתבקש לא לעשות כל שימוש באתר ו/או בשירותים המוענקים במסגרתו. ויודגש, כל המבצע פעולה באתר מצהיר כי הנו מודע להוראות תנאי השימוש ומקבלם, וכי לא תהא לו ו/או למי מטעמו כל טענה ו/או תביעה כנגד בעלי האתר ו/או מפעיליו ו/או מי מטעמם מלבד טענות הקשורות בהפרת התחייבויות בעלי האתר ו/או מפעיליו על פי תנאי השימוש.
                                                            כשרות להשתמש באתר
                                                        </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="flex-row responsive">
                          <div class="flex-7">
                                            <span>
                                                3.
                                            </span>
                          </div>
                          <div class="flex-100">
                            <div class="flex-column">
                              <div class="flex-column">
                                <div>
                                                        <span class="f-18 text-align-start margin-bottom-4">
                                                            כל משתמש רשאי להשתמש באתר על מנת לרכוש מוצרים ו/או שירותים, בכפוף למילוי התנאים המצטברים המפורטים להלן:
                                                        </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="flex-row responsive">
                          <div class="flex-7">
                                            <span>
                                                3.1.
                                            </span>
                          </div>
                          <div class="flex-100">
                            <div class="flex-column">
                              <div class="flex-column">
                                <div>
                                                        <span class="f-18 text-align-start margin-bottom-4">
                                                            המשתמש הנו כשיר לבצע פעולות משפטיות מחייבות; במידה והנך קטין (מתחת לגיל 18) או אינך זכאי לבצע פעולות משפטיות ללא אישור אפוטרופוס, הנך נדרש לידע את הוריך ו/או את האפוטרופוסים החוקיים שלך ("ההורים") בדבר הוראות תקנון זה ולקבל את אישורם לביצוע כל פעילות, מכל סוג שהוא, במסגרת האתר. על ההורים חלה אחריות ליידע את הקטינים המעוניינים לגלוש באתר בדבר התקנון וכן לפקח על פעילות הקטינים בכדי שהקטינים יפעלו על פי תנאי תקנון זה. כל פעילות אשר תבוצע על ידי הקטינים באתר מהווה הסכמה של הקטינים ו/או ההורים לאמור בתנאי התקנון.
                                                        </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="flex-row responsive">
                          <div class="flex-7">
                                            <span>
                                                3.2.
                                            </span>
                          </div>
                          <div class="flex-100">
                            <div class="flex-column">
                              <div class="flex-column">
                                <div>
                                                        <span class="f-18 text-align-start margin-bottom-4">
                                                            המשתמש הינו בעל תעודת זהות ישראלית תקפה או תאגיד המאוגד והרשום כדין בישראל.
                                                        </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="flex-row responsive">
                          <div class="flex-7">
                                            <span>
                                                3.3.
                                            </span>
                          </div>
                          <div class="flex-100">
                            <div class="flex-column">
                              <div class="flex-column">
                                <div>
                                                        <span class="f-18 text-align-start margin-bottom-4">
                                                            המשתמש הינו בעל כרטיס אשראי תקף שהונפק בישראל ע"י אחת מחברות כרטיסי האשראי או אמצעי תשלום אחר המוסכם על פאוורלינק.

                                                        </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="flex-row responsive">
                          <div class="flex-7">
                                            <span>
                                                3.4.
                                            </span>
                          </div>
                          <div class="flex-100">
                            <div class="flex-column">
                              <div class="flex-column">
                                <div>
                                                        <span class="f-18 text-align-start margin-bottom-4">
                                                            המשתמש הוא בעל תא דואר אלקטרוני ברשת האינטרנט ובעל כתובת בישראל.

                                                        </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End PAge Content -->
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Terms',
    computed: {},
    data() {
      return {};
    },
    components: {},
    mounted() {
    },
  };
</script>
<style scoped>
  p {
    text-align: justify;
  }

  li {
    list-style: square;
  }

  ul {
    padding-left: 20px;
  }

  h2 {
    font-size: 1.5em;
  }
</style>



// WEBPACK FOOTER //
// src/components/About/Terms.vue